export default __webpack_public_path__ + "static/media/arrow_up.b9d2303f.svg";